import fontawesome from '@fortawesome/fontawesome';

import {
  faCheck,
} from '@fortawesome/fontawesome-pro-light';

fontawesome.library.add(
  faCheck,
);



// WEBPACK FOOTER //
// ./src/utils/font-awesome.js